import { http, HttpResponse } from 'msw';

import { apiRoutes } from '@features/campaigns/performance/consts/apiRoutes.ts';
import {
  mockedAISummaryData,
  mockedEmptyAISummaryData,
  mockedGeneratedAISummaryData,
} from '@shared/mocks/requests/aiSummary/aiSummary.fixtures';

export const aiSummaryRequests = [
  // GET endpoint - returns existing summary if available
  http.get(`*${apiRoutes.getAISummary(':campaignId')}`, ({ params }) => {
    const { campaignId } = params;

    // Return null for campaigns without existing summary
    if (campaignId === 'no-summary-campaign') {
      return HttpResponse.json(null);
    }

    // Return empty summary for campaigns with empty summary
    if (campaignId === 'empty-summary-campaign') {
      return HttpResponse.json(mockedEmptyAISummaryData);
    }

    // Default: return existing summary
    return HttpResponse.json(mockedAISummaryData);
  }),

  // POST endpoint - generates new summary
  http.post(`*${apiRoutes.generateAISummary(':campaignId')}`, ({ params }) => {
    const { campaignId } = params;

    // Simulate generation failure for specific campaign
    if (campaignId === 'generation-error-campaign') {
      return HttpResponse.json(null, { status: 500 });
    }

    // Simulate empty generation result
    if (campaignId === 'empty-generation-campaign') {
      return HttpResponse.json(mockedEmptyAISummaryData);
    }

    // Default: return newly generated summary
    return HttpResponse.json(mockedGeneratedAISummaryData);
  }),
];
